import Sockette from "sockette";
import { updateLiveAircraft } from "./aircraftSlice";
import { Logger } from "../../tools/Logger";
let sockette: Sockette;
const TAG = "relay";

console.log(process.env);

export const subscribeToRelay = () => async (dispatch: any) => {
  Logger.info(TAG, `subscribeToRelay`);
  try {
    let interval: NodeJS.Timeout;
    try {
      if (sockette) {
        sockette.close();
      }
    } catch {}

    sockette = new Sockette(`wss://relay.manna.aero?live=true`, {
      timeout: 5e3,
      maxAttempts: 10,
      onopen: () => {},
      onmessage: (message) => {
        if (message?.data === "TELEMETRY SUBSCRIBED") {
        } else {
          dispatch(consumeAircraftMessage(message?.data));
        }
      },
      onreconnect: () => {},
      onclose: (e) => {
        console.log(e);
        clearInterval(interval);
      },
      onerror: (err) => {},
    });
  } catch (err) {
    console.log(err);
  }
};

const consumeAircraftMessage = (message: any) => (dispatch: any) => {
  try {
    const data = JSON.parse(message);

    dispatch(updateLiveAircraft(data));
  } catch (err) {}
};
